import { render, staticRenderFns } from "./tab-micepec-records.vue?vue&type=template&id=fc021fc8&scoped=true"
import script from "./tab-micepec-records.vue?vue&type=script&lang=js"
export * from "./tab-micepec-records.vue?vue&type=script&lang=js"
import style0 from "./tab-micepec-records.vue?vue&type=style&index=0&id=fc021fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc021fc8",
  null
  
)

export default component.exports